import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductErrorCodeDataService, ProductErrors, ProductErrorsDocContent } from '@vi-succ/products-domain';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EtProductErrorCodeDataService implements ProductErrorCodeDataService {
  constructor(private http: HttpClient) {}

  getErrorCodes(salesOrg: string, language: string, materialNumber: string): Observable<ProductErrors> {
    return this.http.get<ProductErrors>(`${environment.backend.url}/faults`, {
      params: {
        productId: materialNumber,
        salesOrg: salesOrg,
        locale: language,
      },
    });
  }

  getProductErrorCodesDoc(language: string, errorId: string, docId: string): Observable<ProductErrorsDocContent> {
    return this.http.get<ProductErrorsDocContent>(`${environment.backend.url}/faults/${errorId}/docs/${docId}`, {
      params: {
        locale: language,
      },
    });
  }
}
